import skeleton from 'react-loading-skeleton'
import styled from 'styled-components'

interface SkeletonStyledProps {
  aspectRatio: string
}

export const ImageSkeletonContainer = styled.div<SkeletonStyledProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
`

export const StyledSkeleton = styled(skeleton)<SkeletonStyledProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
`
